import React, { useState, useEffect } from 'react';
import { useUser } from '../UserContext';
import PrizeNavigation from '../components/PrizeNavigation';
import styles from './Unauthorized.module.css';


const Unauthorized = () => {
  const { user } = useUser();

  return (
    <>
      <div>
        <PrizeNavigation navigationButtonArea="/2813821-1@2x.png" />
      </div>
      <div className={styles.unauthHeader}>
        <h3 className={styles.unauthTitle}>Oops!</h3>
        <p>It seems like you're not a member of this league. Check with your commissioner to see if you need to be invited.</p>
      </div>
    </>
  );
};

export default Unauthorized;